import { useNavigate } from "react-router-dom";
import React, { useState } from "react";
import Alert from "../common/Alert";

const SignUpForm = ({handleSignUp}: { handleSignUp: (x: any) => Promise<string>}) => {
  const navigate = useNavigate();
  const [errors, setErrors] = useState<any[]>([]);
  const [formData, setFormData] = useState({
    username: '',
    password: '',
    first_Name: '',
    last_Name: '',
    email: '',
  });

  const handleChange = (evt:any) => {
    const {name, value} = evt.target;
    setFormData(fData => {
      return {
        ...fData,
        [name]: value,
      }
    });
  };

  const handleSubmit = async(evt:any) => {
    evt.preventDefault();
    try {
        await handleSignUp(formData);
        navigate("/");
    } catch(e) {
        setErrors([e]);
    }
  }

  return (
    <div >
    <div>
      {errors && <Alert errors={errors} />}
      <div>
        <h2>
          Sign up for an account:
        </h2>
      </div>
      <form  onSubmit={handleSubmit}>
        <div>
          <div>
            <label htmlFor="SignUpForm-username"> Username </label>
            <input onChange={handleChange} value={formData.username} id="SignUpForm-username" name="username" required autoComplete="current-username"  placeholder="Username" />
          </div>
          <div>
            <label htmlFor="SignUpForm-password">Password</label>
            <input onChange={handleChange} value={formData.password} id="SignUpForm-password" name="password" type="password" autoComplete="current-password" required placeholder="Password" />
          </div>


          <div>
            <label htmlFor="SignUpForm-firstName"> First Name </label>
            <input onChange={handleChange} value={formData.first_Name} id="SignUpForm-firstName" name="firstName" required autoComplete="firstName"   placeholder="First Name" />
          </div>
          <div>
            <label htmlFor="SignUpForm-lastName">Last Name</label>
            <input onChange={handleChange} value={formData.last_Name} id="SignUpForm-lastName" name="lastName" type="lastName" autoComplete="current-lastName" required placeholder="Last Name" />
          </div>
          <div>
            <label htmlFor="SignUpForm-email"> email </label>
            <input onChange={handleChange} value={formData.email} type="email" id="SignUpForm-email" name="email" required autoComplete="email"   placeholder="Email address" />
          </div>
        </div>

        <div>
          <button type="submit">
            Sign up
          </button>
        </div>
      </form>
    </div>
  </div>
  );
}

export default SignUpForm;